import { combineReducers } from 'redux';
import { authentication } from 'reducers/authentication.reducer';
import { alert } from 'reducers/alert.reducer';
import { account } from 'reducers/account.reducer';
import { georesource } from 'reducers/georesource.reducer'
import { customer } from 'reducers/customer.reducer';
import { functionality } from 'reducers/functionality.reducer';
import { permission } from 'reducers/permission.reducer';
import { servicenumbertype } from 'reducers/service-number-type.reducer';
import { dnis } from 'reducers/dnis.reducer';
import { pricing } from 'reducers/pricing.reducer';
import { vendor } from 'reducers/vendor.reducer';
import { order } from 'reducers/order.reducer';
import { notification } from 'reducers/notification.reducer';
import { notificationtype } from 'reducers/notification-type.reducer';
import { report } from 'reducers/report.reducer';
import { config } from 'reducers/config.reducer';
import { invnumber } from 'reducers/invnumber.reducer';
import { carrier } from 'reducers/carrier.reducer';
import { call } from 'reducers/call.reducer';
import { filedownload } from 'reducers/filedownload.reducer';



import phrasebook from '../store/phrasebook';
import { loggedpermissions } from 'reducers/loggedpermissions'


const rootReducer = combineReducers({
  authentication,
  loggedpermissions,
  alert,
  customer,
  functionality,
  permission,
  account,
  phrasebook,
  georesource,
  servicenumbertype,
  dnis,
  pricing,
  vendor,
  order,
  notification,
  notificationtype,
  report,
  config,
  invnumber,
  call,
  filedownload,
  carrier
});

export default rootReducer;
